// extracted by mini-css-extract-plugin
module.exports = {"root":"CaptainOption_root__kDYHD","row":"CaptainOption_row__dM41z","changed":"CaptainOption_changed__yTFeX"};